var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "search_svg__svg-safari-fix",
  viewBox: "0 0 20 20",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.233 2.007a6 6 0 0 1 4.58 9.873l3.774 3.773a1 1 0 0 1-1.414 1.414l-3.893-3.892A6 6 0 1 1 8.233 2.007m0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
  clipRule: "evenodd"
})));
export default SvgSearch;